/**
 * 签署标签数据接口文档
 */
import { Method } from '../core';
import { API, SOURCE } from '../config';

const api = API;

export default {
  // 获取签署流程信息
  operations: {
    url: `${api}/rest/v1/signflow/participantInfos`,
    method: Method.GET,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
    // mode: Mode.fetch
  },

  // 发起签署
  initiate: {
    url: `${api}/rest/v1/signflow/initiate`,
    method: Method.POST,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      },
      docPosList: {
        $type: Array
      }
    }
  },

  // 保存流程信息
  update: {
    url: `${api}/rest/v1/signflow/update`,
    method: Method.PUT,
    body: {
      flowId: {
        $type: [String, Number],
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      },
      userFolderId: {
        $type: String,
        $default: true
      },
      docName: {
        $type: String,
        $required: true
      },
      flowType: {
        $type: [Number, String],
        $required: true
      },
      isRealSign: {
        $type: Number,
        $required: true
      },
      signDeadline: {},
      contractStartline: {},
      contractDeadline: {},
      description: {},
      payMethod: {
        $type: [Number, String],
        $required: true
      },
      receivers: {
        $type: Array,
        $required: true
      }
    }
  },

  // 签署流程详情
  detail: {
    url: `${api}/rest/v1/signflow/detail`,
    method: Method.GET,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },

  // 删除签署流程文档
  deleteDoc: {
    url: `${api}/rest/v1/signflow/deleteDoc`,
    method: Method.DELETE,
    body: {
      flowDocId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },

  // 批量上传文件 md5
  // "key":"a","filename":"b","filetype":"c"
  checkmd5: {
    url: `${api}/rest/v1/file/upload`,
    method: Method.POST,
    body: {
      flowId: {
        $type: String
      },
      docName: {
        $type: String,
        $required: true
      },
      flowType: {
        $required: true
      },
      md5List: {
        $type: Array,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },

  // 批量更新文件名称
  rename: {
    url: `${api}/rest/v1/file/rename`,
    method: Method.PUT,
    body: {
      items: {
        $type: Array,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },

  // 签署
  sign: {
    url: `${api}/rest/v1/signflow/sign`,
    method: Method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      isAutoComplete: {
        $type: [Number, String],
        $required: true
      },
      code: {
        $required: true
      },
      validateType: {
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      },
      docSignInfoList: {
        $type: Array,
        $required: true
      }
    }
  },
  
  // 更新用户新手状态 http://127.0.0.1:8084/service/rest/preferences
  preferences: {
    url: `${api}/rest/preferences`,
    method: Method.PUT,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      name: {
        $type: String,
        $default: 'need_show_guide_page'
      },
      value: {
        $type: String
      },
      accountUid: {
        $type: String
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/sign.js